import { BareButton } from '@calendly/ui/components/bare-button';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { ArrowChevronUpMiniIcon, ArrowChevronDownMiniIcon } from '@calendly/ui/components/icons';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useNewAdminModal } from '../use-new-admin-modal';
const dropdownTriggerComponentIsOpenCss = "d1bsbmo6";
const dropdownTriggerComponentDisabledCss = "d1r1g2r9";
const dropdownTriggerComponentIsNewAdminModalCss = "d10zcwoy";
const dropdownTriggerComponentCss = "d1txrdze";
const DropdownTriggerComponent = forwardRef((props, ref) => {
  const {
    isOpen,
    disabled,
    ...restProps
  } = props;
  const isNewAdminModal = useNewAdminModal();
  return <BareButton ref={ref} {...restProps} className={classNames(dropdownTriggerComponentCss, {
    [dropdownTriggerComponentIsOpenCss]: isOpen,
    [dropdownTriggerComponentDisabledCss]: disabled,
    [dropdownTriggerComponentIsNewAdminModalCss]: isNewAdminModal
  }, props.className)} />;
});
const textContainerIsNewAdminModalCss = "tfb9e8";
const textContainerCss = "t5mohvb";
const TextContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isNewAdminModal = useNewAdminModal();
  return <Component ref={ref} {...restProps} className={classNames(textContainerCss, {
    [textContainerIsNewAdminModalCss]: isNewAdminModal
  }, props.className)} />;
});
const iconContainerIsNewAdminModalCss = "i1xuee7";
const iconContainerCss = "i18knys1";
const IconContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isNewAdminModal = useNewAdminModal();
  return <Component ref={ref} {...restProps} className={classNames(iconContainerCss, {
    [iconContainerIsNewAdminModalCss]: isNewAdminModal
  }, props.className)} />;
});
const DropdownTrigger = ({
  isOpen,
  disabled = false,
  ...props
}) => <DropdownTriggerComponent isOpen={isOpen} disabled={disabled} {...props} />;
export const DropdownButton = ({
  label,
  disabled = false,
  children
}) => {
  const [toggleDropdown, Dropdown, isOpen, {
    dropdownId
  }] = useDropdown(false, true);
  const handleToggle = e => {
    if (disabled) return;
    e.stopPropagation();
    toggleDropdown();
  };
  return <>
      <DropdownTrigger aria-label={label} aria-expanded={isOpen} aria-controls={dropdownId} onClick={e => handleToggle(e)} isOpen={isOpen} disabled={disabled} id="invite-user-modal-user-type-dropdown">
        <TextContainer>{label}</TextContainer>
        <IconContainer>
          {isOpen ? <ArrowChevronUpMiniIcon /> : <ArrowChevronDownMiniIcon />}
        </IconContainer>
      </DropdownTrigger>
      <Dropdown>
        {children}
      </Dropdown>
    </>;
};

require("./dropdown_button.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./dropdown_button.js");